import { c as _c } from "react/compiler-runtime";
import TrailerAlertOverlay from '@/app/[locale]/(worlds)/[roomId]/components/TrailerAlertOverlay';
import TrailerCarouselEmptyState from '@/app/[locale]/(worlds)/[roomId]/components/TrailerCarouselEmptyState';
import TrailerCarouselImageOverlay from '@/app/[locale]/(worlds)/[roomId]/components/TrailerCarouselImageOverlay';
import TrailerCarouselSlide from '@/app/[locale]/(worlds)/[roomId]/components/TrailerCarouselSlide';
import OptimizedImage from '@/components/OptimizedImage';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useTrailerViewMediaContext } from '@/context/TrailerViewMediaContext';
import { useEnableFull3d } from '@/hooks/useEnableFull3d';
import { cn } from '@/lib/utils';
import { useState } from 'react';
const TrailerCarousel = () => {
  const $ = _c(20);
  const {
    mediaList,
    currentIndex,
    setCurrentIndex,
    currentMedia,
    handleVideoEnded,
    isLoading,
    isEmpty,
    playKey
  } = useTrailerViewMediaContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const showRoomCover = Boolean(roomData.image);
  const enableFull3d = useEnableFull3d();
  const [closeAlert, setCloseAlert] = useState(false);
  const t0 = isEmpty && "bg-linear-to-b from-[#1c3356] to-[#131b26]";
  const t1 = !enableFull3d;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = cn("pointer-events-auto relative aspect-video h-full w-full overflow-hidden", t0, {
      "md:rounded-[15px] landscape:rounded-none": t1
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeAlert) {
    t3 = !closeAlert && <TrailerAlertOverlay setCloseAlert={setCloseAlert} />;
    $[3] = closeAlert;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currentIndex || $[6] !== currentMedia || $[7] !== handleVideoEnded || $[8] !== isEmpty || $[9] !== isLoading || $[10] !== mediaList || $[11] !== playKey || $[12] !== roomData.image || $[13] !== setCurrentIndex || $[14] !== showRoomCover) {
    t4 = isLoading ? <>{showRoomCover ? <OptimizedImage src={roomData.image} alt="" fill={true} loading="eager" fetchPriority="high" sizes="(max-width: 1023px) 100vw, (max-width: 1439px) 66vw, (max-width: 1599px) 60vw, 1296px" className="z-base object-cover opacity-20 lg:opacity-100" /> : <ViverseSkeleton aria-hidden={true} className="absolute inset-0 rounded-none" />}<TrailerCarouselImageOverlay url={roomData?.image} eager={!showRoomCover} /></> : isEmpty ? <TrailerCarouselEmptyState /> : <TrailerCarouselSlide media={currentMedia} onEnded={handleVideoEnded} mediaList={mediaList} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} playKey={playKey} />;
    $[5] = currentIndex;
    $[6] = currentMedia;
    $[7] = handleVideoEnded;
    $[8] = isEmpty;
    $[9] = isLoading;
    $[10] = mediaList;
    $[11] = playKey;
    $[12] = roomData.image;
    $[13] = setCurrentIndex;
    $[14] = showRoomCover;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export default TrailerCarousel;